import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "p-toolbar box-panel shadow-5 flex" }
const _hoisted_6 = { class: "p-toolbar-group-end" }
const _hoisted_7 = { class: "col-12 lg:col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_CrudTable = _resolveComponent("CrudTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.loaded && _ctx.viewDetail && _ctx.getPropertyValue(_ctx.CrudTableTypeConst.SELECTEDROW))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "header"),
                      _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "buttons"),
                        _withDirectives(_createVNode(_component_Button, {
                          style: {"cursor":"pointer"},
                          icon: "pi pi-arrow-left",
                          class: "ml-1 p-button-secondary p-button-outlined",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToList()))
                        }, null, 512 /* NEED_PATCH */), [
                          [_directive_tooltip, 'Volver al listado']
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "detail")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createVNode(_component_CrudTable, {
            ref: "crudTableControl",
            rootParentId: _ctx.rootParentId,
            container: _ctx.container,
            Component: _ctx.Component,
            id: _ctx.getPropertyValue(_ctx.CrudTableTypeConst.ID),
            style: _normalizeStyle(_ctx.getPropertyValue(_ctx.CrudTableTypeConst.STYLE)),
            class: _normalizeClass(_ctx.getPropertyValue(_ctx.CrudTableTypeConst.CLASS)),
            name: _ctx.getPropertyValue(_ctx.CrudTableTypeConst.NAME),
            disabled: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.DISABLED),
            visible: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.VISIBLE),
            placeholder: _ctx.getPropertyValue(_ctx.CrudTableTypeConst.PLACEHOLDER),
            showBtnSearch: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWBTNSEARCH),
            showBtnClear: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWBTNCLEAR),
            showBtnCloseTabs: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWBTNCLOSETABS),
            showPaginator: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWPAGINATE),
            editAllExceptKeys: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.EDITALLEXCEPTKEYS),
            maxRegs: _ctx.getPropertyNumberValue(_ctx.CrudTableTypeConst.MAXREGS),
            canAddNewItem: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.CANADDNEWITEM),
            canImport: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.CANIMPORT),
            canUpdateMassive: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.CANUPDATEMASSIVE),
            showActionMenu: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWACTIONMENU),
            showSearch: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWSEARCH),
            showActionDetail: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWACTIONDETAIL),
            showPaginate: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWPAGINATE),
            showHeaderDetail: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.SHOWHEADERDETAIL),
            canDeleteItem: _ctx.getPropertyBooleanValue(_ctx.CrudTableTypeConst.CANDELETEITEM),
            customAddNew: _ctx.customAddNew,
            "onClick:viewDetail": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSelectedRow($event, true))),
            "onClick:SelectRow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSelectedRow($event, false))),
            "onClick:addCustom": _ctx.openCustomNew,
            menuActionItems: _ctx.menuItems
          }, null, 8 /* PROPS */, ["rootParentId", "container", "Component", "id", "style", "class", "name", "disabled", "visible", "placeholder", "showBtnSearch", "showBtnClear", "showBtnCloseTabs", "showPaginator", "editAllExceptKeys", "maxRegs", "canAddNewItem", "canImport", "canUpdateMassive", "showActionMenu", "showSearch", "showActionDetail", "showPaginate", "showHeaderDetail", "canDeleteItem", "customAddNew", "onClick:addCustom", "menuActionItems"]), [
            [_vShow, _ctx.loaded && !_ctx.viewDetail && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE)],
            [_directive_tooltip, _ctx.getPropertyValue(_ctx.CrudTableTypeConst.TOOLTIP)]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.opNewRegister)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 1,
          ref: "slotControls",
          visible: _ctx.opNewRegister,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.opNewRegister) = $event)),
          header: "Añadir registro",
          maximizable: "",
          modal: "",
          styleClass: "mx-3 sm:mx-0 sm:w-full md:w-8 lg:w-6",
          contentStyleClass: "border-round-bottom border-top-1 surface-border p-0",
          onHide: _ctx.hideCustomNew
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              id: "guardar",
              label: "Guardar",
              icon: "pi pi-save",
              class: "mr-2 p-button-rounded p-button-primary p-button-outlined",
              onClick: _ctx.saveCustomForm
            }, null, 8 /* PROPS */, ["onClick"])
          ]),
          default: _withCtx(() => [
            (_ctx.opNewRegister)
              ? _renderSlot(_ctx.$slots, "new", { key: 0 })
              : _createCommentVNode("v-if", true)
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["visible", "onHide"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}